import { isStaffSurface } from '@titan/shared';
import { Link } from 'react-router';
import { useSession } from '../../session/SessionProvider.js';
import { ScreenBody, ScreenHeader } from '../../shell/Shell.js';
import { Card } from '../../ui/index.js';

export interface InDevelopmentProps {
  /** Lowercase in source, e.g. "ticketing platform · tickets". */
  eyebrow: string;
  title: string;
  description: string;
}

/**
 * The empty view every product module renders until it ships. Copy is a draft pending
 * confirmation; see OPEN_QUESTIONS.md.
 */
export function InDevelopment({ eyebrow, title, description }: InDevelopmentProps) {
  const { me } = useSession();
  const staff = me ? isStaffSurface(me.actor) : false;
  return (
    <>
      <ScreenHeader eyebrow={eyebrow} title={title} description={description} />
      <ScreenBody>
        <Card
          title="In development"
          description={`${title} is being built. It appears here the day it ships; your entitlement is already in place, so nothing changes on your side.`}
        >
          {staff && (
            <p>
              <Link to="/demo">See the designed experience in the demo</Link>
            </p>
          )}
        </Card>
      </ScreenBody>
    </>
  );
}
